const state = {
    cycles: [],
    suggestion: null,
    dispatches: [],
    dispatch: null,
    loading: false,
    error: null,
};

const actions = {
    showCycles({ commit }) {
        return axios.get('/api/production-suggestions').then(response => {
            commit('SET_CYCLES', response.data.data);
            return response;
        });
    },
    showSuggestion({ commit }, cycle) {
        commit('SET_LOADING', true);
        commit('SET_ERROR', null);

        return axios.get(`/api/production-suggestions/${cycle}`)
            .then(response => {
                commit('SET_SUGGESTION', response.data.data);
                return response;
            })
            .catch(error => {
                commit('SET_ERROR', error.response && error.response.data
                    ? error.response.data.message
                    : 'Não foi possível calcular a sugestão.');
                throw error;
            })
            .finally(() => commit('SET_LOADING', false));
    },
    showDispatches({ commit }) {
        return axios.get('/api/production-suggestions/dispatches').then(response => {
            commit('SET_DISPATCHES', response.data.data);
            return response;
        });
    },
    showDispatch({ commit }, dispatch) {
        commit('SET_LOADING', true);
        commit('SET_ERROR', null);

        return axios.get(`/api/production-suggestions/dispatches/${dispatch}`)
            .then(response => {
                commit('SET_DISPATCH', response.data.data);
                return response;
            })
            .catch(error => {
                commit('SET_ERROR', error.response && error.response.data
                    ? error.response.data.message
                    : 'Não foi possível calcular o pedido.');
                throw error;
            })
            .finally(() => commit('SET_LOADING', false));
    },
};

const mutations = {
    SET_CYCLES(state, cycles) {
        state.cycles = cycles;
    },
    SET_SUGGESTION(state, suggestion) {
        state.suggestion = suggestion;
    },
    SET_DISPATCHES(state, dispatches) {
        state.dispatches = dispatches;
    },
    SET_DISPATCH(state, dispatch) {
        state.dispatch = dispatch;
    },
    SET_LOADING(state, loading) {
        state.loading = loading;
    },
    SET_ERROR(state, error) {
        state.error = error;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
